module.exports = __webpack_public_path__ + "static/media/video-call_disabled_light.2c28cb78.svg";